import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ReactComponent as IconUsers } from '../../../public/images/icons/users.svg';

import './index.scss';

ChartJS.register(ChartDataLabels, ArcElement, Tooltip, Legend);

const DoughnutChart = ({ accepts, declines }) => {
  const [invitations, setInvitation] = useState(0);
  const [data, setData] = useState({
    datasets: [
      {
        data: [100],
        backgroundColor: [
          '#CCD0DE',
        ],
        borderWidth: 0,
        cutout: '85%',
        showTooltips: false,
      },

    ],
    tooltip: false,
  });

  useEffect(() => {
    accepts && setData({
      datasets: [
        {
          data: [declines[9], accepts[9]],
          backgroundColor: [
            '#E3414B',
            '#0994A9',
          ],
          borderWidth: 0,
          cutout: '85%',
          showTooltips: false,
        },

      ],
      tooltip: false,
    });
    accepts && setInvitation(declines[9] + accepts[9]);
  }, [accepts]);

  const options = {
    plugins: {
      tooltip: {
        enabled: false,
      },
      datalabels: {
        display: false,
      },
    },
    hover: { mode: null },
  };

  return <div className='doughnut-chart'>
    <Doughnut data={data} className='doughnut-chart__component' options={options} />
    <div className='doughnut-chart__inner'>
      <div className='doughnut-chart__center'>
        <IconUsers />
        <p className='doughnut-chart__invitations'><span className='doughnut-chart__invitations_num'>{invitations}</span> invitations</p>
      </div>
    </div>
  </div>;
};

export default DoughnutChart;
